<template>
    <font-awesome-icon
        icon="info-circle"
        @click="toDetalhar()"
        size="lg"
        class="icon-button p-text-primary"
        title="Detalhar"
        v-if="$temAcessoView('AGECON-CHECKIN-01')"
    />
</template>

<script>
export default {
    props: {
        checkIn: {
            type: Object,
        },
    },

    methods: {
        toDetalhar() {
            this.$router.push({
                name: 'AgenciaConceito_CheckIns_Detalhar',
                params: {
                    id: this.checkIn.checkInId,
                },
            });
        },
    },
};
</script>
